import { Box, Button, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { comparingWithControlsStyle } from '@/components/content/HdmSkucomparer/styles';

export const ComparingWithControls = ({
	comparingWithIndex,
	totalAssociations,
	onNext,
	onPrevious,
}: {
	totalAssociations: number;
	comparingWithIndex: number;
	onNext: () => void;
	onPrevious: () => void;
}) => (
	<Box display="flex" alignItems="center" gap={1}>
		<Button onClick={onPrevious} sx={comparingWithControlsStyle.button}>
			<ChevronLeftIcon />
		</Button>

		<Typography noWrap>{`${comparingWithIndex + 1} / ${totalAssociations}`}</Typography>

		<Button onClick={onNext} sx={comparingWithControlsStyle.button}>
			<ChevronRightIcon />
		</Button>
	</Box>
);
